// オブジェクト配置時の既定サイズ（ステージ座標 px）。
//
// ツールバーからの配置（canvas-stage.tsx の onPlaceObject）が使う既定値の単一正本。
// このうちテキストの初期高さ（textInitialHeight）だけは、コネクタからのオブジェクト自動作成
// （connector-auto-create.ts）も参照する（ほかはサイズを接続元から継承するため参照しない）。
// 片方だけ変更されて挙動が食い違うのを防ぐため、定数だけでなく算出式ごとここへ集約する。

export const STICKY_DEFAULT_W = 200;
export const STICKY_DEFAULT_H = 160;
export const TEXT_DEFAULT_W = 240;
/** テキストの既定の高さ。文字サイズに応じた初期高さの下限として textInitialHeight が使う。 */
export const TEXT_DEFAULT_H = 48;

/**
 * 文字サイズから決まるテキストの初期高さ。極端に大きい文字でも最低 1 行分を確保する。
 * ツールバーからの配置とコネクタからの自動作成で結果が食い違わないよう、式ごとここを正本にする。
 */
export function textInitialHeight(fontSize: number): number {
  return Math.max(TEXT_DEFAULT_H, Math.ceil(fontSize * 1.6));
}

/** 表図形の既定サイズと初期セル数（ヘッダ 1 行 + 本文 2 行）。 */
export const TABLE_DEFAULT_W = 360;
export const TABLE_DEFAULT_H = 96;
export const TABLE_DEFAULT_ROWS = 3;
export const TABLE_DEFAULT_COLUMNS = 3;
